import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appRestrictNumberInput]',
  standalone: false
})
export class RestrictNumberInputDirective {

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    // console.log({'isValidNumber':this.el.nativeElement.value})
    
    // Allow "-" only if it's the first character (for negative numbers)
    if (this.el.nativeElement.value.length === 0 && event.key === '-') {
      return;
    }

    if (!allowedKeys.includes(event.key) && event.key !== '-') {
      event.preventDefault();
    }
  }
}
